import { Pipe, PipeTransform } from '@angular/core';
import { environment } from '@portals/environments';

@Pipe({
	name: 's3Video',
})
export class S3VideoPipe implements PipeTransform {
	transform(value?: string): string {
		return `https://${environment.s3Bucket}.s3.amazonaws.com/${value}`;
	}
}
